const styles = () => ({
  titleCard: {
    fontWeight: 600,
  },
});

export default styles;
